export default __webpack_public_path__ + "static/media/saveTrees.d06b1b10.png";